import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { HeaderComponent } from '@layout/header/header.component';
import { FooterComponent } from '@layout/footer/footer.component';
import { SidenavComponent } from '@layout/sidenav/sidenav.component';
import { ToastOutletComponent } from '@shared/ui/toast/toast-outlet.component';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, SidenavComponent, ToastOutletComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly authService = inject(AuthService);
  private readonly document = inject(DOCUMENT);

  constructor() {
    afterNextRender(() => {
      // Remove any alternate icon fallback so the browser uses the SVG favicon
      this.document
        .querySelector<HTMLLinkElement>('link[rel="alternate icon"]')
        ?.remove();

      this.document
        .querySelector<HTMLLinkElement>('link[rel="icon"]')
        ?.setAttribute('href', `favicon-${environment.envName}.svg`);
    });
  }
}
